"use strict";

var _slicedToArray = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAwsRegionByCountryCode = exports.isRegionSupportedForBrand = exports.convertCountryStringToIsoCountryCode2Char = void 0;

var types_1 = require("../types");
/**
 * Attempt to convert a string to a 2 character ISO country code
 * @param country Country in an unknown format
 * @returns ISO Country Code. Returns "undefined" if no country could be determined
 */


function convertCountryStringToIsoCountryCode2Char(country) {
  var normalizedCountry = country.toUpperCase().trim(); // Country is in format "US"

  if (types_1.ISO2_ISO_MAPPING[normalizedCountry]) {
    return normalizedCountry;
  } // Country is in format "USA"


  if (types_1.ISO_ISO2_MAPPING[normalizedCountry]) {
    return types_1.ISO_ISO2_MAPPING[normalizedCountry];
  }

  return types_1.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING[normalizedCountry];
}

exports.convertCountryStringToIsoCountryCode2Char = convertCountryStringToIsoCountryCode2Char;
/**
 * Given a brand and region, determine if the region is supported for the brand.
 *
 * @param {Brand} brand
 * The Brand.
 *
 * @param {IsoCountryCode2Char} region
 * A region.
 *
 * @returns {boolean}
 * true - The region is supported for the given brand.
 * false - The region is NOT supported for the given brand.
 */

var isRegionSupportedForBrand = function isRegionSupportedForBrand(brand, region) {
  var _a, _b;

  return (_b = (_a = types_1.BRAND_TO_SUPPORTED_REGIONS_MAPPING[brand]) === null || _a === void 0 ? void 0 : _a.includes(region)) !== null && _b !== void 0 ? _b : false;
};

exports.isRegionSupportedForBrand = isRegionSupportedForBrand;
/**
 * Given a market region, it returns the AWS region associated
 *
 * @param {IsoCountryCode2Char} region: market region
 *
 * @returns {AwsRegions} The AWS region associated to the market
 */

var getAwsRegionByCountryCode = function getAwsRegionByCountryCode(region) {
  var _a;

  var _ref = (_a = Object.entries(types_1.AWS_REGION_MARKETS).find(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        markets = _ref4[1];

    return markets.includes(region);
  })) !== null && _a !== void 0 ? _a : [types_1.AwsRegions.USE1],
      _ref2 = _slicedToArray(_ref, 1),
      awsRegion = _ref2[0];

  return awsRegion;
};

exports.getAwsRegionByCountryCode = getAwsRegionByCountryCode;